import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function SpiritualLoader() {
  const {
    hasSelectedLanguage,
    setLanguage
  } = useLanguage();
  if (hasSelectedLanguage) return null;
  return <AnimatePresence data-id="element-85">
      <motion.div initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 1
    }} className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden" data-id="element-86">
        {/* Aurora background - same as main page */}
        <div className="absolute inset-0 -z-10" data-id="element-87">
          {/* Base cream gradient */}
          <div className="absolute inset-0 bg-gradient-to-b from-[#FBF8F3] via-[#F5F1E8] to-[#F9F5EF]" data-id="element-88" />

          {/* Aurora layers - matching main background */}
          <div className="absolute inset-0" data-id="element-89">
            {/* Soft taupe wave 1 */}
            <div className="absolute w-[800px] h-[800px] rounded-full blur-3xl opacity-20" style={{
            background: 'radial-gradient(circle, rgba(212, 165, 116, 0.4) 0%, rgba(200, 180, 150, 0.2) 50%, transparent 70%)',
            top: '-20%',
            left: '10%',
            animation: 'float1 20s ease-in-out infinite'
          }} data-id="element-90" />

            {/* Gentle gold wave 2 */}
            <div className="absolute w-[700px] h-[700px] rounded-full blur-3xl opacity-15" style={{
            background: 'radial-gradient(circle, rgba(232, 184, 109, 0.3) 0%, rgba(220, 200, 160, 0.15) 50%, transparent 70%)',
            top: '10%',
            right: '5%',
            animation: 'float2 25s ease-in-out infinite'
          }} data-id="element-91" />

            {/* Cream wave 3 */}
            <div className="absolute w-[600px] h-[600px] rounded-full blur-3xl opacity-18" style={{
            background: 'radial-gradient(circle, rgba(245, 241, 232, 0.5) 0%, rgba(235, 225, 210, 0.25) 50%, transparent 70%)',
            top: '30%',
            left: '20%',
            animation: 'float3 22s ease-in-out infinite'
          }} data-id="element-92" />

            {/* Soft taupe wave 4 */}
            <div className="absolute w-[750px] h-[750px] rounded-full blur-3xl opacity-16" style={{
            background: 'radial-gradient(circle, rgba(200, 180, 150, 0.35) 0%, rgba(212, 165, 116, 0.2) 50%, transparent 70%)',
            bottom: '10%',
            left: '40%',
            animation: 'float4 18s ease-in-out infinite'
          }} data-id="element-93" />

            {/* Delicate gold wave 5 */}
            <div className="absolute w-[650px] h-[650px] rounded-full blur-3xl opacity-14" style={{
            background: 'radial-gradient(circle, rgba(232, 184, 109, 0.25) 0%, rgba(245, 230, 211, 0.15) 50%, transparent 70%)',
            bottom: '20%',
            right: '15%',
            animation: 'float5 24s ease-in-out infinite'
          }} data-id="element-94" />
          </div>
        </div>

        {/* Language selector */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="relative z-10 bg-white/90 backdrop-blur-sm rounded-2xl p-10 shadow-2xl max-w-md w-full mx-6" data-id="element-95">
          <h2 className="font-serif text-3xl text-[#2C4A3E] text-center mb-8" data-id="element-96">
            Selecciona tu idioma
          </h2>
          <p className="text-center text-[#4A4A4A] mb-8" data-id="element-97">
            Select your language
          </p>

          <div className="space-y-4" data-id="element-98">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => setLanguage('es')} className="w-full bg-gradient-to-br from-[#E8B86D] via-[#D4A574] to-[#C87941] text-[#2C4A3E] py-4 rounded-xl text-lg font-semibold transition-all duration-300 shadow-lg" data-id="element-99">
              🇲🇽 Español Latino
            </motion.button>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => setLanguage('en')} className="w-full bg-gradient-to-r from-[#2C4A3E] to-[#3D5F4E] text-[#FBF8F3] py-4 rounded-xl text-lg font-semibold shadow-lg hover:shadow-xl transition-shadow" data-id="element-100">
              🇺🇸 English
            </motion.button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}